var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C5.10457 12 6 11.1046 6 10C6 8.89543 5.10457 8 4 8C2.89543 8 2 8.89543 2 10C2 11.1046 2.89543 12 4 12ZM6.80445 11.0677C6.9308 10.736 7 10.3761 7 10C7 9.62372 6.93073 9.26362 6.80423 8.93176L14.5472 5.72782C15.0903 6.49739 15.9865 7 17 7C18.6569 7 20 5.65685 20 4C20 2.34315 18.6569 1 17 1C15.3431 1 14 2.34315 14 4C14 4.28596 14.04 4.56257 14.1147 4.82455L6.29027 8.06221C5.73997 7.41246 4.91815 7 4 7C2.34315 7 1 8.34315 1 10C1 11.6569 2.34315 13 4 13C4.91838 13 5.74037 12.5873 6.29067 11.9373L14.1149 15.1749C14.0401 15.437 14 15.7138 14 16C14 17.6569 15.3431 19 17 19C18.6569 19 20 17.6569 20 16C20 14.3431 18.6569 13 17 13C15.9867 13 15.0907 13.5024 14.5476 14.2717L6.80445 11.0677ZM17 18C18.1046 18 19 17.1046 19 16C19 14.8954 18.1046 14 17 14C15.8954 14 15 14.8954 15 16C15 17.1046 15.8954 18 17 18ZM19 4C19 5.10457 18.1046 6 17 6C15.8954 6 15 5.10457 15 4C15 2.89543 15.8954 2 17 2C18.1046 2 19 2.89543 19 4Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.eab9bee8ddb2d9ed1aaad815b3db0ad0.svg";
export { ForwardRef as ReactComponent };